import { render, staticRenderFns } from "./SkupTema2Details.vue?vue&type=template&id=b16487c2&scoped=true&"
import script from "./SkupTema2Details.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16487c2",
  null
  
)

export default component.exports